export default "__VITE_ASSET__74a3d1ee__"